import React, { Component } from 'react';
import './ImportConfig.scss';
import history from '../../Routers/history';

import downloadIcon from '../../../assets/icons/ic_download_grey.png';
import thumsUpicon from '../../../assets/icons/ic_thumb_up_blue.png';
import clearIcon from '../../../assets/icons/ic_close_grey.png';

import ImgTag from '../../Elements/Atoms/ImgTag';
import Button from '../../Elements/Atoms/Button';
import { ButtonV3, DropdownButtonSearch } from 'react-ui-lib';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { updateBotValue, updateSelectedBotId, updateBotValueConfig, getBotInfo, getSourceList, updateSelectedSource } from '../../Redux/Actions/uiActions';

import { Link } from 'react-router-dom';

class ImportConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeInputtab: 'upload-tab',
            fileUploaded: false,
            inputKey: new Date().getTime(),
            selectedFileName: '',
            inputData: '',
            sourceList: [],
            selectedSource: null,
            sourceListLoading: false,
        }

        this.textAreaRef = React.createRef();
        this.botIdRef = React.createRef();
        this.serverIpRef = React.createRef();
        this.portRef = React.createRef();
        this.LangRef = React.createRef();
        this.uploadRef = React.createRef();
    }

    fetchSourceList(botId) {
        if (!botId || typeof botId !== 'string' || botId === 'null' || botId === 'undefined' || botId.length <= 10) return;
        this.setState({ sourceListLoading: true });
        this.props.getSourceList(botId, (res) => {
            const savedSourceName = localStorage.getItem('sourceName');
            const matched = savedSourceName && res ? res.find(s => s.sourceName === savedSourceName) : null;
            this.setState({
                sourceList: res || [],
                selectedSource: matched || (res && res.length ? res[0] : null),
                sourceListLoading: false,
            });
        }, (err) => {
            // console.error('getSourceList error:', err);
            this.setState({ sourceListLoading: false });
        });
    }

    componentDidMount() {
        const botId = this.props.selectedBotID || localStorage.getItem('bot_id');
        this.fetchSourceList(botId);
    }

    componentDidUpdate(prevProps) {
        const prevBotId = prevProps.selectedBotID || null;
        const currBotId = this.props.selectedBotID || null;
        if (currBotId && currBotId !== prevBotId && this.state.sourceList.length === 0 && !this.state.sourceListLoading) {
            this.fetchSourceList(currBotId);
        }
    }

    addLabelValue = (uploadStatus) => {
        if(uploadStatus) {
            return (
                <label htmlFor = 'config-upload-input' className = 'config-upload-input-label'>
                    <ImgTag
                        className = 'image'
                        src = {thumsUpicon}
                        alt = 'Upload'
                    />
                    <span className = 'config-uploaded-text'>
                        <span title = {this.state.selectedFileName}>{this.state.selectedFileName}</span>
                        <ImgTag
                            className = 'config-uploaded-image'
                            src = {clearIcon}
                            alt = 'Upload'
                            title = 'Clear Selection'
                            onClick = {
                                (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.setState({fileUploaded: false, inputKey: new Date().getTime(), selectedFileName: '', inputData: ''});
                                }
                            }
                        />
                    </span>
                </label>
            );
        } else {
            return (
                <label htmlFor = 'config-upload-input' className = 'config-upload-input-label'>
                    <ImgTag
                        className = 'image'
                        src = {downloadIcon}
                        alt = 'Upload'
                    />
                    <span>Choose a file or drag it here</span>
                </label>
            );
        }
    }

    loadUploadTab = () => {
        return (
            <div className = 'config-input-tab-container'>
                <input type = 'file' className = 'config-upload-input' id = 'config-upload-input' key = {this.state.inputKey} ref={this.uploadRef} accept = 'application/JSON' onChange = {
                    (e) => {
                        if(e.target && e.target.files && e.target.files[0]) {
                            let fileName = e.target.files[0].name;
                            let checkvalidFiletype = fileName.indexOf('.json');
                            let reader = new FileReader();
                            let currentFileData = '';
                            if(checkvalidFiletype !== -1) {
                                // console.log('valid file type', checkvalidFiletype);
                                reader.readAsText(e.target.files[0]);
                                reader.onload = () => {
                                    currentFileData = reader.result;
                                    this.setState({inputData: currentFileData.toString() });
                                };
                                reader.onerror = () => {
                                    alert('Some error occured please re-upload the file');
                                    console.log(reader.error);
                                };
                                this.setState({fileUploaded: true, selectedFileName: fileName});
                            } else {
                                console.log('invalid file type', checkvalidFiletype);
                                this.setState({fileUploaded: false, inputKey: new Date().getTime(), selectedFileName: '', inputData: ''});
                                alert('Invalid file type uploaded');
                            }
                        }
                    }
                }/>
                {this.addLabelValue(this.state.fileUploaded)}
            </div>
        );
    }

    loadCopyTab = () => {
        return (
            <div className = 'config-input-tab-container'>
                <textarea className = 'config-copy-input' id = 'config-copy-input' name = 'config-copy-input' placeholder = 'Please paste JSON here...' ref={this.textAreaRef} autoFocus spellCheck = 'false' onChange = {
                    (e) => {
                        if(e.target && e.target.value && e.target.value.length) {
                            let inputValue = e.target.value.trim();
                            this.setState({inputData: inputValue.toString() });
                        } else {
                            this.setState({inputData: ''});
                        }
                    }
                }/>
            </div>
        );
    }

    render() {
        const activeUploadTabClass = this.state.activeInputtab === 'upload-tab' ? 'nav-item active' : 'nav-item';
        const activeCopyTabClass = this.state.activeInputtab === 'copy-tab' ? 'nav-item active' : 'nav-item';
        const leftCreateButtonClass = this.state.inputData === '' ? 'config-input-tabs-button theme-button disabled' : 'config-input-tabs-button theme-button';
        let homeBtnUrl = `/${this.props.selectedBotID}`;
        if(!this.props.selectedBotID) {
            homeBtnUrl = '/';
        }
        return (
            <div className = 'create-config-tab'>
                <div className = 'body-section'>
                    <h3 className = 'tab-header'>Import an existing bot config</h3>
                    <div style={{marginBottom: '1rem'}}>
                        <label style={{fontSize: '0.875rem', marginBottom: '0.5rem', display: 'block', color: '#444A52'}}>Select Source</label>
                        <DropdownButtonSearch
                            isSearchActive={false}
                            isLeftIcon={false}
                            text={'Source: ' + (this.state.selectedSource?.sourceName || '-')}
                            itemList={this.state.sourceList.map((item) => ({
                                displayJSX: (
                                    <span style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                                        <span className={'body-container-sub-header__left-items wrap-ellipsis' + (this.state.selectedSource?._id === item._id ? ' selected' : '')}>{item.sourceName}</span>
                                        <span style={this.state.selectedSource?._id === item._id ? {color: '#fff'} : {color: '#8B929B'}}>{(item?.sourceLangISO || 'en').toUpperCase()}</span>
                                    </span>
                                ),
                                title: item.sourceName,
                                name: item.sourceName,
                                value: item._id,
                                idx: item._id,
                                props: {
                                    style: this.state.selectedSource?._id === item._id ? {background: '#2680EB', color: '#fff', fontWeight: '600'} : {},
                                    className: 'dropdown_list_element' + (this.state.selectedSource?._id === item._id ? ' selected' : '')
                                },
                                onClick: (e, clickedItem) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const source = this.state.sourceList.find(elm => elm._id === clickedItem?.value);
                                    this.setState({ selectedSource: source });
                                }
                            }))}
                            customStyles={{width: '100%', justifyContent: 'space-between'}}
                            btnstyle={{backgroundColor: '#fff', border: '1px solid #A6ADB6'}}
                            dropdownStyle={{ zIndex: '99' }}
                            disabled={this.state.sourceList.length <= 1}
                        />
                    </div>
                    <div className = 'config-input-wrapper'>
                        <div className = 'nav nav-tabs config-input-tabs-header' role = 'tablist'>
                            <span className = {activeUploadTabClass} onClick = {() => {
                                this.setState({activeInputtab: 'upload-tab'})
                            }}>
                                Attach JSON File
                                <div className = 'underline'></div>
                            </span>
                            <span className = {activeCopyTabClass} onClick = {() => {
                                if(this.uploadRef && this.uploadRef.current && this.uploadRef.current.value) {
                                    this.setState({fileUploaded: false, inputKey: new Date().getTime(), selectedFileName: '', inputData: ''});
                                }
                                this.setState({activeInputtab: 'copy-tab'})
                            }}>
                                Paste JSON
                                <div className = 'underline'></div>
                            </span>
                        </div>
                        <div className = 'tab-content config-input-tabs-wrapper'>
                            {this.state.activeInputtab === 'upload-tab' ? this.loadUploadTab() : null}
                            {this.state.activeInputtab === 'copy-tab' ? this.loadCopyTab() : null}
                        </div>
                    </div>
                    <div className = 'config-input-tabs-buttons' style={{display: 'flex', justifyContent: 'flex-end'}}>
                        {/* <Button
                            className = {leftCreateButtonClass}
                            value = 'Submit'
                            buttonOnClick = {(e) => {
                                if(this.state.inputData !== '') {
                                    let dataToBeUploaded = this.state.inputData;
                                    let errMsg = '';
                                    let uploadedBotId = '';
                                    try {
                                        dataToBeUploaded = JSON.parse(dataToBeUploaded);
                                    } catch(e) {
                                        alert('Invalid JSON, Please verify and retry');
                                        return;
                                    }
                                    // console.log(this.props.availableBotList);
                                    if(dataToBeUploaded && !dataToBeUploaded.botId) {
                                        errMsg = 'Data has no botId defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.POST_OPTIONS) {
                                        errMsg = 'Data has no POST_OPTIONS defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.OPTIONS) {
                                        errMsg = 'Data has no OPTIONS defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.CUSTOM_BOT_UI) {
                                        errMsg = 'Data has no CUSTOM_BOT_UI defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.SETTINGS) {
                                        errMsg = 'Data has no SETTINGS defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.UI_OPTIONS) {
                                        errMsg = 'Data has no UI_OPTIONS defined'
                                    }
                                    if(errMsg === '') {
                                        uploadedBotId = dataToBeUploaded.botId;
                                        // console.log('UPDATE_SELECTED_BOT_ID',this.props.availableBotList)
                                        let currentElem = this.props.availableBotList.filter(elm => {
                                            return elm.id === uploadedBotId;
                                        });
                                        if(!currentElem.length) {
                                            alert("The bot data provide here doesn't belongs to this team or incorrect, Please verify and retry");
                                            return;
                                        } else {
                                            // console.log('UPDATE_SELECTED_BOT_ID',uploadedBotId, currentElem[0].name);
                                            // this.props.updateBotValue(dataToBeUploaded);
                                            // this.props.updateSelectedBotId(uploadedBotId, currentElem[0].name);
                                            if(!dataToBeUploaded.CUSTOM_BOT_UI.VALUE) {
                                                alert('The bot is not custom, made it custom to make changes, click on okay to proceed');
                                            } else {
                                                
                                            }
                                            dataToBeUploaded.CUSTOM_BOT_UI.VALUE = true;
                                            localStorage.setItem("bot_id", uploadedBotId);
                                            let newData = {};
                                            newData['bot-config'] = dataToBeUploaded;
                                            newData['kbId'] = this.props.kbId;
                                            this.props.updateBotValueConfig(newData, uploadedBotId);
                                            history.push(`/${uploadedBotId}/chatbot`);
                                        }
                                    } else {
                                        alert(errMsg + ', Please verify and retry');
                                        return;
                                    }
                                }
                            }}
                        />
                        <Button
                            className = 'config-input-tabs-button grey-button'
                            value = 'Cancel'
                            buttonOnClick = {(e) => {
                                if(this.textAreaRef && this.textAreaRef.current && this.textAreaRef.current.value) {
                                    this.textAreaRef.current.value = '';
                                }
                                this.setState({fileUploaded: false, inputKey: new Date().getTime(), selectedFileName: '', inputData: ''});
                            }}
                        /> */}
                        <ButtonV3 
                            name = 'Cancel'
                            btnStyleType = "secondary"
                            btnstyle = {{marginRight: '1rem'}}
                            onClick = {(e) => {
                                if(this.textAreaRef && this.textAreaRef.current && this.textAreaRef.current.value) {
                                    this.textAreaRef.current.value = '';
                                }
                                this.setState({fileUploaded: false, inputKey: new Date().getTime(), selectedFileName: '', inputData: ''});
                            }}
                        />
                        <ButtonV3 
                            name = 'Submit'
                            onClick = {(e) => {
                                if(this.state.inputData !== '') {
                                    let dataToBeUploaded = this.state.inputData;
                                    let errMsg = '';
                                    let uploadedBotId = '';
                                    try {
                                        dataToBeUploaded = JSON.parse(dataToBeUploaded);
                                    } catch(e) {
                                        alert('Invalid JSON, Please verify and retry');
                                        return;
                                    }
                                    // console.log(this.props.availableBotList);
                                    if(dataToBeUploaded && !dataToBeUploaded.botId) {
                                        errMsg = 'Data has no botId defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.POST_OPTIONS) {
                                        errMsg = 'Data has no POST_OPTIONS defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.OPTIONS) {
                                        errMsg = 'Data has no OPTIONS defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.CUSTOM_BOT_UI) {
                                        errMsg = 'Data has no CUSTOM_BOT_UI defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.SETTINGS) {
                                        errMsg = 'Data has no SETTINGS defined'
                                    } else if(dataToBeUploaded && !dataToBeUploaded.UI_OPTIONS) {
                                        errMsg = 'Data has no UI_OPTIONS defined'
                                    }
                                    if(errMsg === '') {
                                        uploadedBotId = dataToBeUploaded.botId;
                                        // console.log('UPDATE_SELECTED_BOT_ID',this.props.availableBotList)
                                        let currentElem = this.props.availableBotList.filter(elm => {
                                            return elm.id === uploadedBotId;
                                        });
                                        if(!currentElem.length) {
                                            alert("The bot data provide here doesn't belongs to this team or incorrect, Please verify and retry");
                                            return;
                                        } else {
                                            // console.log('UPDATE_SELECTED_BOT_ID',uploadedBotId, currentElem[0].name);
                                            // this.props.updateBotValue(dataToBeUploaded);
                                            // this.props.updateSelectedBotId(uploadedBotId, currentElem[0].name);
                                            if(!dataToBeUploaded.CUSTOM_BOT_UI.VALUE) {
                                                alert('The bot is not custom, made it custom to make changes, click on okay to proceed');
                                            } else {
                                                
                                            }
                                            dataToBeUploaded.CUSTOM_BOT_UI.VALUE = true;
                                            if (this.state.selectedSource) {
                                                dataToBeUploaded.sourceName = this.state.selectedSource.sourceName;
                                                dataToBeUploaded.sourceLangISO = this.state.selectedSource.sourceLangISO;
                                                localStorage.setItem('sourceName', this.state.selectedSource.sourceName);
                                                this.props.updateSelectedSource(this.state.selectedSource);
                                            }
                                            localStorage.setItem("bot_id", uploadedBotId);
                                            this.props.getBotInfo(uploadedBotId);
                                            let newData = {};
                                            newData['bot-config'] = dataToBeUploaded;
                                            newData['kbId'] = this.props.kbId;
                                            this.props.updateBotValueConfig(newData, uploadedBotId);
                                            history.push(`/${uploadedBotId}/chatbot`);
                                        }
                                    } else {
                                        alert(errMsg + ', Please verify and retry');
                                        return;
                                    }
                                }
                            }}
                        />
                    </div>
                </div>

                <div className = 'create-config-devider'>
                    OR
                </div>
                
                <div className = 'config-input-tabs-buttons bottom-navigation-button'>
                    <Link to = {homeBtnUrl}>
                        <ButtonV3
                            // className = 'config-input-tabs-button border-button'
                            name = 'Home'
                            title = 'Home'
                            btnStyleType = "secondary"
                            btnstyle = {{marginRight: '1rem'}}
                        />
                    </Link>
                    <Link to = '/createconfig'>
                        <ButtonV3
                            // className = 'config-input-tabs-button theme-button'
                            name = 'Create config'
                            title = 'Create config'
                        />
                    </Link>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        kbId: state.UiReducer && state.UiReducer.kbId ? state.UiReducer.kbId : undefined
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateBotValue,
        updateSelectedBotId,
        updateBotValueConfig,
        getBotInfo,
        getSourceList,
        updateSelectedSource,
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ImportConfig));
